module.exports = __webpack_public_path__ + "img/fi-rr-shop.9b27f99d.svg";